import React from 'react';
const HelpInformation = () => {
    return (<>
      <p data-testid='report-help-text'>
        For questions regarding your report content or delivery, please contact your account team.
      </p>
    </>);
};
export default HelpInformation;
